export default "__VITE_ASSET__4224c701__$_?component__"